export enum CanvasPreviewErrorReason {
  AGENT_FOUNDRY_CANVAS_NOT_CONFIGURED = 'AGENT_FOUNDRY_CANVAS_NOT_CONFIGURED',
}

export function getPreviewErrorMessage(error: unknown): string {
  const statusCode = getErrorStatusCode(error);
  if (statusCode === 424) {
    return 'This canvas is not ready to preview yet.';
  }
  if (statusCode === 404) {
    return 'The canvas could not be found.';
  }
  return 'Unable to load the canvas.';
}

export function getPreviewErrorReason(error: unknown): CanvasPreviewErrorReason | null {
  if (typeof error !== 'object' || error == null || !('responseJSON' in error)) {
    return null;
  }
  const {responseJSON} = error;
  if (typeof responseJSON !== 'object' || responseJSON == null || !('errorReason' in responseJSON)) {
    return null;
  }
  return responseJSON.errorReason === CanvasPreviewErrorReason.AGENT_FOUNDRY_CANVAS_NOT_CONFIGURED
    ? CanvasPreviewErrorReason.AGENT_FOUNDRY_CANVAS_NOT_CONFIGURED
    : null;
}

function getErrorStatusCode(error: unknown): number | null {
  if (typeof error !== 'object' || error == null || !('status' in error)) {
    return null;
  }
  const {status} = error;
  return typeof status === 'number' ? status : null;
}
